const InstallTerms: React.FC<{
  variant: "cctv" | "alarm"
}> = ({ variant }) => {
  return variant === "cctv" ? (
    <>
      <p>
        All our security system installations are carried out to a very high
        standard, and due to our unique cable routing and installation methods,
        99% of the time, you won&rsquo;t see a single cable.
      </p>

      <p>
        We use Hikvision for all our CCTV systems, unless otherwise requested or
        specified, which comes with a 3-year warranty and support.
      </p>

      <p>
        There are no ongoing costs or subscription fees that you are required to
        pay.
      </p>

      <p>
        The prices obtained via the online booking system are for a standard
        installation.
      </p>

      <p className="font-bold">A standard installation is assuming;</p>

      <ol>
        <li>
          The recording unit (DVR/NVR) will be installed in to the loft space
          (this is the recommended place for security, and you don&rsquo;t have
          to get back to it as everything is done remotely), and that the loft
          space isn&rsquo;t converted.
        </li>

        <li>
          That the cameras are to be mounted off the main face of the house. If
          any of the cameras are going off an extension or garage, 9 times out
          of 10 there will not be any price increase, but its usually best to
          email us a picture either before, or once you have placed the booking
          and we will confirm if this will be covered under the same price.
        </li>

        <li>
          You have broadband and a smartphone for the system to be accessed
          remotely, via smartphones, tablets, laptops and PC&rsquo;s. If you do
          not have broadband, no problem. We can situate the recorder next to a
          TV for you to use the system on there.
        </li>
      </ol>
    </>
  ) : (
    <>
      <p>
        All our security system installations are carried out to a very high
        standard.
      </p>
      <p>
        The systems have a Wi-Fi card in them, and are app compatible meaning if
        you have broadband, you will be able to use the system via the app.
      </p>
      <p>
        We use Pyronix for all our Wireless Alarm Systems, unless otherwise
        requested or specified, which comes with a 2-year warranty and support.
      </p>
      <p>
        There are no ongoing costs or subscription fees to use the alarm system,
        however after the first 12 months, to continue receiving push
        notifications and using the alarm from your phone, there is an annual
        charge of £30 for use of the Pyronix Cloud.
      </p>
      <p>The sensors have up to a 30m wireless range and are pet-friendly.</p>

      <p>
        The prices obtained via the online booking system are for a standard
        installation.
      </p>

      <p className="font-bold">A standard installation is assuming;</p>

      <ol>
        <li>The main panel will be somewhere accessible.</li>

        <li>
          The External Sirens are going in accessible places and not above a
          conservatory for example.
        </li>

        <li>
          You have broadband and a smartphone for the system to be accessed
          remotely. If you do not have broadband, no problem, it will still work
          fine as an alarm system, you just won&rsquo;t get alerts and be able
          to arm/disarm remotely.
        </li>
      </ol>
    </>
  )
}

export default InstallTerms
